import { Box, Breakpoint } from "@mui/material";
import { cardWidth } from "@utils/ui-utils";
import { CSSProperties, PropsWithChildren } from "react";

interface Props {
  /** Data test id for testing */
  dataTestId?: string;
  
  /**
   * Optional custom width for child items in the container.
   * Can be a fixed width or responsive object.
   * Defaults to `cardWidth` if not provided.
  */
  itemWidth?: CSSProperties["width"] | {
    [key in Breakpoint]?: CSSProperties["width"];
  };
}

/**
 * A container for the tiles, for example the projects and groups tiles. It makes sure that the tiles are
 * aligned properly.
 */
export function TilesContainer({
  children,
  dataTestId,
  itemWidth,
}: PropsWithChildren<Props>): JSX.Element {
  return (
    <Box
      component="div"
      data-testid={dataTestId}
      sx={{
        display: "flex",
        flexWrap: "wrap",
        columnGap: "20px",
        "& > *": {
          width: itemWidth || cardWidth,
          flexGrow: 0,
        },
      }}
    >
      {children}
    </Box>
  );
}
